"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactRouterDom = require("react-router-dom");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var RouterContext = /*#__PURE__*/_react["default"].createContext({});

var GetParams = function GetParams(_ref) {
  var Component = _ref.Component,
      props = _objectWithoutProperties(_ref, ["Component"]);

  return /*#__PURE__*/_react["default"].createElement(Component, _extends({}, props, {
    params: _objectSpread({}, (0, _reactRouterDom.useParams)())
  }));
};

var _default = function _default(Component) {
  return function (_ref2) {
    var props = _extends({}, _ref2);

    var _useRouteMatch = (0, _reactRouterDom.useRouteMatch)(),
        path = _useRouteMatch.path,
        alt1 = "".concat(path, "/:action"),
        alt2 = "".concat(path, "/:action/:urlArg"),
        location = (0, _reactRouterDom.useLocation)(),
        history = (0, _reactRouterDom.useHistory)(),
        routerProps = _react["default"].useMemo(function () {
      return {
        basePath: path,
        useRouter: true,
        location: location,
        history: history
      };
    }, [path, location, history]);

    return /*#__PURE__*/_react["default"].createElement(RouterContext.Provider, {
      value: routerProps
    }, /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Switch, null, /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Route, {
      exact: true,
      path: path
    }, /*#__PURE__*/_react["default"].createElement(Component, _extends({}, props, routerProps, {
      path: path
    }))), /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Route, {
      exact: true,
      path: [alt1, alt2]
    }, /*#__PURE__*/_react["default"].createElement(GetParams, _extends({}, props, routerProps, {
      path: path,
      Component: Component
    })))));
  };
};

exports["default"] = _default;